import { Flex, FlexProps } from '@ui-library/misc';
import { FixMe } from '@utils/types';
import { Checkbox } from 'antd';
import Input from '@ui-library/input';
import Table from '@ui-library/table';
import styled from 'styled-components';
import { is, isNot } from 'typescript-styled-is';

const borderColor = '#DEDEDE';
export const TableViewWrapper = styled.div`
  .edited {
  }
  width: 100%;
`;
export const CheckRow = styled(Checkbox)`
  transform: scale(0.9);
`;
export const MappingTable = styled<FixMe>(Table)`
  &&& {
    flex-wrap: wrap;
    display: flex;
    overflow-x: scroll;
    min-height:340px;
    border: 1px solid ${borderColor};
    background-color: #FFFFFF;
    border-radius:6px;
    box-shadow:unset;
    .ant-table-tbody > tr.ant-table-row-level-1:hover > td {
      background: unset;
    }
    .ant-spin-nested-loading{
      width:100%;
    }
    .ant-table{
      background-color:unset;
    }
    tr{
      &:hover{
        td{
            background:none;
            &.editMode{
              background-color: rgba(255,199,0,0.2);
            }
        }
      }
      ${is('filled')`
        &:not(:last-child) {
          td{
            border-bottom:1px solid #DEDEDE;
          }
        }
      `}
      ${isNot('filled')`
          td{
            border-bottom:1px solid #DEDEDE;
          }
      `}
    }
    td {
      white-space:nowrap;
      overflow:auto;
      padding:10px;
      padding-bottom:0px;
      max-width:150px;
      border:unset;
      &:not(:last-child) {
        border-right: 1px solid ${borderColor};
      }
      font-size:12px
    }
    th {
        border-bottom: 1px solid ${borderColor};
        color: #6C757D;
        font-weight:500
        font-size:12px
        &:not(:last-child) {
          border-right: 1px solid ${borderColor};
        }
        background-color: unset;
    }
  }
  
`;

export const EditColumnWrapper = styled<FixMe>(Flex)`
  .editIcon {
    display: none;
  }
  &:hover {
    .editIcon {
      display: ${(props) => (props.editMode ? 'inherit' : 'none')};
    }
  }
  input {
    border: unset;
    &:focus {
      border: unset;
      outline: none;
    }
  }
`;

export const ButtonWrapper = styled.div`
  margin-left: auto;
  display: flex;
  height: 12px;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;

// stable header

export const HeaderWrapper = styled<FixMe>(Flex)<FlexProps>`
  margin-bottom: 12px;
`;
export const SearchInput = styled(Input)`
  width: 160px !important;
`;
